module.exports = __webpack_public_path__ + "neurocognitive-tests-and-domain-scoring-process.f33ff88f9699c981a1ab7cd888e9a0c8.png";